import { NEWS_PANEL_CREATE } from 'client/redux/news/constants';
import * as actions from 'client/redux/news/actionCreators';

export const newsNewPanelCreate = fields => dispatch => {
  return dispatch(actions.newsCreate(NEWS_PANEL_CREATE, fields));
};
